/**
 * Layout-variant route wrappers for the multi-agent workspace.
 *
 * Each renders the SAME MultiAgentRoute with a different layout variant, so the
 * five arrangements can be opened on their own routes (/multi-agent/<variant>)
 * and compared side by side locally. Only the panel arrangement differs —
 * chat / editor / agent functionality is identical to /multi-agent.
 */
import { MultiAgentRoute } from "@/pages/multi-agent/MultiAgentRoute";

export function MultiAgentLayoutClassic() {
  return <MultiAgentRoute variant="classic" />;
}

export function MultiAgentLayoutFocus() {
  return <MultiAgentRoute variant="focus" />;
}

export function MultiAgentLayoutCommand() {
  return <MultiAgentRoute variant="command" />;
}

export function MultiAgentLayoutSplit() {
  return <MultiAgentRoute variant="split" />;
}

export function MultiAgentLayoutZen() {
  return <MultiAgentRoute variant="zen" />;
}
